import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ViewPage from "./pages/ViewPage";
import TestDetailPage from "./pages/TestDetailPage";
import PasswordPage from "./pages/PasswordPage";
import { AUTH_STORAGE_KEY, AUTH_STORAGE_VALUE } from "./constants/auth";

// Matches production URL: https://dashboard.noccarc-web.com/preuse?data=...
const BASENAME = "/preuse";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => localStorage.getItem(AUTH_STORAGE_KEY) === AUTH_STORAGE_VALUE
  );

  return (
    <BrowserRouter basename={BASENAME}>
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <ViewPage />
            ) : (
              <PasswordPage onAuthenticated={() => setIsAuthenticated(true)} />
            )
          }
        />
        <Route path="/detail" element={<TestDetailPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;